export default {
  header: {
    home: '首頁',
    categories: '分類',
    about: '關於',
    searchPlaceholder: '搜尋遊戲...',
    toggleDarkMode: '切換暗黑模式',
    toggleLightMode: '切換明亮模式',
    changeLanguage: '切換語言'
  },
  nav: {
    home: '首頁',
    categories: '分類',
    popular: '熱門',
    favorites: '收藏',
    search: '搜尋...',
    login: '登入',
    register: '註冊',
    myProfile: '我的資料',
    settings: '設定',
    logout: '登出',
    darkMode: '暗黑模式',
    lightMode: '明亮模式',
    language: '語言',
    about: '關於'
  },
  footer: {
    about: '關於我們',
    contact: '聯絡我們',
    contactUs: '聯絡我們',
    policy: '隱私權政策',
    terms: '使用條款',
    copyright: '© {year} GoGameVault. 保留所有權利。',
    playOnline: '線上遊戲',
    bestGames: '最佳遊戲',
    newGames: '新遊戲',
    popularGames: '熱門遊戲',
    followUs: '追蹤我們',
    disclaimer: '所有遊戲歸原創者所有，本站不聲稱擁有任何相關權利。',
    introText: '最好的線上免費遊戲平台。無需下載，無需註冊，只有樂趣！',
    quickLinks: '快速連結',
    popularCategories: '熱門分類',
    contactText: '有疑問、建議或回饋？我們很樂意聽到您的聲音！',
    aboutUs: '關於我們'
  },
  gameCard: {
    play: '開始遊戲',
    new: '新遊戲',
    popular: '熱門'
  },
  shareButtons: {
    share: '分享',
    copyLink: '複製連結',
    facebook: '分享到Facebook',
    twitter: '分享到Twitter',
    whatsapp: '分享到WhatsApp',
    telegram: '分享到Telegram',
    copied: '已複製！'
  },
  searchBar: {
    search: '搜尋',
    placeholder: '尋找你喜歡的遊戲...'
  },
  share: {
    title: '分享',
    copy: '複製連結',
    copied: '已複製',
    instagramNotSupported: 'Instagram暫不支援直接分享連結'
  },
  defaultGameImage: {
    text: '遊戲圖片'
  }
}; 